"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _List = _interopRequireDefault(require("../../List/List"));
var _constants = require("../../constants");
var _Tribe = _interopRequireDefault(require("../../Svg/TYWSymbols/Tribe"));
var GiveUsACall = function GiveUsACall(_ref) {
  var _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? 'tyw' : _ref$brand,
    isPoweredBy = _ref.isPoweredBy;
  var listNumbers = !isPoweredBy ? _constants.PHONE_NUMBERS[brand.toUpperCase()] : _constants.PHONE_NUMBERS.PB[brand.toUpperCase()];
  var showDecoration = brand === 'tyw';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component position-relative"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-left text-md"
  }, "Give us a call"), /*#__PURE__*/_react["default"].createElement("p", null, "Give our team a call to discuss any questions you have with your current booking or with any queries you have on how to make a booking."), /*#__PURE__*/_react["default"].createElement("br", null), !!listNumbers && listNumbers.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-md margin-bottom-sm"
  }, /*#__PURE__*/_react["default"].createElement(_List["default"], {
    items: listNumbers,
    noNotificationText: true,
    noMaxHeight: true
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "margin-top-md"
  }, "London time: 9am - 6pm (Mon-Thurs) 9am - 5pm (Fri) closed on Bank Holidays. If your country is not listed please call +44 1389 656 005"), showDecoration && /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute width-100% height-100%",
    style: {
      top: 0,
      left: 0
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute",
    style: {
      display: 'inline-block',
      top: '10%',
      left: '10%',
      zIndex: 0,
      opacity: 0.1
    }
  }, /*#__PURE__*/_react["default"].createElement(_Tribe["default"], {
    className: "icon--xxxl",
    fill: "#DC474B"
  }))));
};
var _default = exports["default"] = GiveUsACall;